import { format, unwrapFunctionStore } from 'svelte-i18n';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const editingCampaign = {
  popover: {
    title: 'Editing a Campaign',
    description: 'Need to make changes? No problem. Update your campaign details, targeting, or ad content anytime.',
    onNextClick: () => {
      const layoutBtns = document.querySelectorAll('div.toolbar > div.filters > div.display-options > div');

      if (layoutBtns[0].children[0].classList.contains('active')) {
        layoutBtns[0].children[1].click();

        setTimeout(() => {
          GLOBAL_DRIVER_OBJECT.moveNext();
        }, 200);
      } else {
        GLOBAL_DRIVER_OBJECT.moveNext();
      }
    }
  }
};
